import type { JSX } from 'react'
import type { ISkeletonUnitProps } from '../../SkeletonUnit'

import { SkeletonUnit } from '../../SkeletonUnit'

export interface IChannelTitleSkeletonUnitProps extends ISkeletonUnitProps {}

export const ChannelTitleSkeletonUnit = ({
  height = '56px',
  flexGrow = '1',
  ...rest
}: IChannelTitleSkeletonUnitProps): JSX.Element => (
  <SkeletonUnit height={height} flexGrow={flexGrow} {...rest} />
)
